import React from "react";
import styled from "styled-components";

import { Icon } from "@fluentui/react/lib/Icon";
import { Link } from "react-router-dom";

export interface HeroCardProps {
    title: string;
    info: string;
    urlTitle: string;
    url: string;
    imageUrl?: string;
    reverse?: boolean;
    lightBackground?: boolean;
}

export default function HeroCard(props: HeroCardProps): JSX.Element {
    return (
        <Container reverse={props.reverse} lightBg={props.lightBackground}>
            <div className="image">
                {props.imageUrl && <img width="330" src={props.imageUrl} alt={props.title} />}
            </div>
            <div className="title-container">
                <h2 className="title" aria-label={props.title}>{props.title}</h2>
                <div className="info" aria-label={props.info}>{props.info}</div>
                <Link to={props.url} className="link">
                    {props.urlTitle}
                    <Icon className="small-icon" iconName="ChevronRight" />
                </Link>
            </div>
        </Container>
    );
}

const Container = styled.div<{ reverse?: boolean, lightBg?: boolean }>`
    display: flex;
    flex-direction: row;
    flex-flow: ${props => props.reverse ? 'row-reverse' : 'row'};
    padding: 0 3rem;
    background: ${props => props.lightBg ? 'var(--color-surface)' : 'var(--color-background)'};

    .image, .title-container {
        flex: 1 0 0;
        padding: 4rem;
    }

    .link {
        display: block;
        padding: 1rem 0;
        font-weight: 600;
    }

    .link i {
        font-weight: 800;
    }

    .title {
        font-size: 4.2rem;
        line-height: 1.24;
        color: var(--color-on-surface);
        margin-bottom: 1.5rem;
    }
`